import Software from './models/Software'
import { loadSoftware } from '@/api/environment'

export default {

  namespaced: true,

  state: {
    software: new Software,
    manager: {
      software: new Software,
      version: {},
      findings: [],
    }
  },

  mutations: {
    ...Software.mutations()
  },

  actions: {
    loadSoftware: ({commit}, payload) => new Promise((resolve, reject) => {
      loadSoftware(payload, ({data}) => {
        commit('setManager', data)
        resolve()
      }, reject)
    })
  },

  getters: {
    software: state => state.software,
    manager: state => state.manager
  }

}
